function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgItemRemove = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "none"
  },
  fill: "none",
  d: "M12 4L4 12M4 4L12 12",
  stroke: "#333333",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
export default SvgItemRemove;